<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-12">
        <div class="is-italic">
          {{ $t('detailCommandeTlpe.infoCommentaire.commentaireInterne') }}
        </div>
        <p class="has-text-weight-bold">{{ commandeTlpe.commentaireInterne }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    commandeTlpe: {
      type: Object,
      required: true,
    },
  },
};

</script>
